import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import StelDataGrid from "../StelDataGrid";

function CustomHeader({ title }) {
  if (!title) return null;
  return (
    <Typography sx={{ fontSize: 20, fontWeight: 600, padding: "12px 10px" }}>
      {title}
    </Typography>
  );
}

CustomHeader.propTypes = {
  title: PropTypes.string,
};
CustomHeader.defaultProps = {
  title: "",
};

function TroubleshootTable({
  title,
  columns,
  hideFooter,
  rows,
  paginationModel,
  totalCount,
  setPaginationModel,
  onRowClick,
}) {
  return (
    <StelDataGrid
      columns={columns}
      rows={rows || []}
      loading={false}
      paginationModel={paginationModel}
      pageSizeOptions={[10, 25, 50, 100]}
      rowCount={totalCount}
      onPaginationModelChange={setPaginationModel}
      paginationMode="server"
      onRowClick={onRowClick}
      slots={{
        toolbar: CustomHeader,
      }}
      slotProps={{
        toolbar: { title },
      }}
      hideFooter={hideFooter}
    />
  );
}

TroubleshootTable.propTypes = {
  title: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  paginationModel: PropTypes.shape({
    pageSize: PropTypes.number,
    page: PropTypes.number,
  }),
  totalCount: PropTypes.number,
  setPaginationModel: PropTypes.func,
  hideFooter: PropTypes.bool,
  onRowClick: PropTypes.func,
};
TroubleshootTable.defaultProps = {
  title: "",
  hideFooter: false,
  paginationModel: { pageSize: 10, page: 0 },
  totalCount: 0,
  setPaginationModel: () => {},
  onRowClick: () => {},
};

export default TroubleshootTable;
